/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';
import qs from 'qs';
import lodash from 'lodash';

// initial state
const state = {
  cancelToken: axios.CancelToken.source(),
  baseUrl: null,
  activeSection: 'Overview',
  member: null,
  member_id: null,
  user_id: null,
  user: null,
  contact_id: null,
  attendee_id: null,
  dashboardItem: {
    icon: 'fa-th-large',
    url: 'dashboard',
    title: 'Member Overview',
  },
  lmsItem: {
    icon: 'fa-graduation-cap',
    url: 'online-learning-login',
    title: 'Online Learning Login',
  },
  permissions: [],
  children: [],
  version: null,
  fuelEmployee: false,
  meetingAttendee: false,
  meetingAgenda: null,
  payInvoiceUrl: null,
  batteryStoreUrl: null,
  displayedModal: null,
  modalData: null,
  globalLoading: true,
  devEnv: CONFIG.get('ENV') === 'DEV',
  loaders: {
    memberChange: false,
    sendingMessage: false,
  },
};

// getters
const getters = {
  baseUrl: (state) => state.baseUrl,
  devEnv: (state) => state.devEnv,
  activeSection: (state) => state.activeSection,
  member: (state) => state.member,
  memberName: (state) => (state.member ? state.member.name : ''),
  member_id: (state) => state.member_id,
  user: (state) => state.user,
  user_id: (state) => state.user_id,
  contact_id: (state) => state.contact_id,
  attendee_id: (state) => state.attendee_id,
  version: (state) => state.version,
  fuelEmployee: (state) => state.fuelEmployee,
  meetingAttendee: (state) => state.meetingAttendee,
  meetingAgenda: (state) => state.meetingAgenda,
  batteryStoreUrl: (state) => state.batteryStoreUrl,
  payInvoiceUrl: (state) => state.payInvoiceUrl,
  displayedModal: (state) => state.displayedModal,
  modalData: (state) => state.modalData,
  permissions: (state) => state.permissions,
  topBarNavItems: (state, getters) => lodash.reject(
    state.permissions,
    (permission) => permission.perm_desc === 'can_contact_am_rd'
      || (permission.perm_desc === 'can_view_fuel_funds' && !getters.member.fuel_funds)
      || (permission.perm_desc === 'can_view_digital_promo' && !getters.member.digital_promo)
  ),
  menuItems: (state, getters) => state.meetingAttendee ? getters.topBarNavItems : lodash.concat(state.dashboardItem, getters.topBarNavItems, state.lmsItem),
  children: (state, getters) => lodash.reject(state.children, (child) => child.business_id === getters.member_id),
  loaders: (state) => state.loaders,
  globalLoading: (state) => state.globalLoading,
  am: (state) => (state.member.am ? state.member.am : null),
  rm: (state) => (state.member.rm ? state.member.rm : null),
  canContactTeam: (state) => lodash.map(state.permissions, 'perm_desc').includes('can_contact_am_rd'),
  memberChangeLoading: (state) => state.loaders.memberChange,
};

// actions
const actions = {
  async cancelAjax({ commit, state }) {
    await state.cancelToken.cancel();
    commit('SET_PROPERTY', { key: 'cancelToken', value: axios.CancelToken.source() });
    return;
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
  showModal({ commit }, payload) {
    commit('SET_PROPERTY', { key: 'displayedModal', value: payload });
    if (!payload) {
      commit('SET_PROPERTY', { key: 'modalData', value: payload });
    }
  },
  sendMessage({ commit, dispatch }, payload) {
    commit('TOGGLE_LOADING', { key: 'sendingMessage', value: true });
    return axios.post(`${CONFIG.get('BASE_URL')}/api/messaging/send/`, qs.stringify(payload))
      .then(() => {
        commit('TOGGLE_LOADING', { key: 'sendingMessage', value: false });
        dispatch('flash/addMessage', { text: 'Message Sent' }, { root: true });
        this.closeModal();
      })
      .catch((err) => {
        commit('TOGGLE_LOADING', { key: 'sendingMessage', value: false });
        dispatch('flash/addMessage', { text: 'No text entered', type: 'error' }, { root: true });
        console.error(err);
      });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
